import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {AppLinkBuilder} from '../../../utils';
import {IoniconsFilled} from '@pt/pt-models';
import {
  ApplicationAdministrator
} from 'it/primatoo/openapi/api/org/schemas/application/getapplicationfordetailsresponse/_getapplicationfordetailsresponse/ApplicationAdministrator';

@Component({
  selector: 'pt-details-administrators',
  templateUrl: './details-administrators.component.html',
  styleUrls: ['./details-administrators.component.scss']
})
export class DetailsAdministratorsComponent implements OnChanges {
  @Input() administrators?: ApplicationAdministrator[];
  public noAdministratorFound = false;
  IconUser = IoniconsFilled.user;

  openAdministrator(admin: ApplicationAdministrator) {
    window.open(AppLinkBuilder.linkOfEntity('userResources', admin.id), '_blank');
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.noAdministratorFound = !!this.administrators && !!this.administrators.find(a => !a.sysAdmin);
  }
}
